import { PDFDocument } from 'pdf-lib'
import { makeBlankPage, uid } from '../store/projectStore.js'

export async function buildDocumentFromImage(file) {
  const buffer = await file.arrayBuffer()
  const bytes = new Uint8Array(buffer)

  const isJpg = /\.(jpe?g)$/i.test(file.name) || file.type === 'image/jpeg'
  const isPng = /\.png$/i.test(file.name) || file.type === 'image/png'
  if (!isJpg && !isPng) {
    throw new Error(`Unsupported image type: ${file.name}`)
  }

  // Decode the image to discover its native pixel dimensions, then build a
  // 1-page PDF whose page matches those dimensions (1 px = 1 pt).
  const dims = await new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight })
    img.onerror = reject
    img.src = URL.createObjectURL(file)
  })

  const pdf = await PDFDocument.create({ updateMetadata: false })
  const embedded = isJpg ? await pdf.embedJpg(bytes) : await pdf.embedPng(bytes)
  const page = pdf.addPage([dims.width, dims.height])
  page.drawImage(embedded, { x: 0, y: 0, width: dims.width, height: dims.height })
  const pdfBytes = await pdf.save({ useObjectStreams: false })

  const docId = uid()
  return {
    id: docId,
    file,
    originalName: file.name,
    size: file.size,
    bytes: pdfBytes,
    pages: [
      makeBlankPage({
        id: uid(),
        originalIndex: 0,
        width: dims.width,
        height: dims.height,
        rotation: 0,
        sourceKind: 'image',
      }),
    ],
    formFields: null,
    formScanned: false,
  }
}
